import { Component } from '@angular/core';

import { LogoTypeEnum } from '~/component/logo/enums/logo-type.enum';

@Component({
  selector: 'app-qr-code-error',
  templateUrl: './qr-code-error.component.html',
  styleUrls: ['./qr-code-error.component.scss'],
})
export class QrCodeErrorComponent {
  public readonly logoType = LogoTypeEnum;

  constructor() {}
}
